var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Tooltip as ChakraTooltip, useColorModeValue } from "@chakra-ui/react";
import { Placement, Spacing, ColorScheme } from "../../core/constants";
/**
 * A tooltip is a brief, informative message that appears when a user interacts with an element.
 * Tooltips are usually initiated in one of two ways: through a mouse-hover gesture or through
 *  a keyboard-hover gesture.
 */
const Tooltip = forwardRef((_a, ref) => {
    var { className, label, placement = Placement.bottom, hasArrow = true, children, colorScheme, variantColor = ColorScheme.gray } = _a, rest = __rest(_a, ["className", "label", "placement", "hasArrow", "children", "colorScheme", "variantColor"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    const bgColor = useColorModeValue(`${scheme}.500`, `${scheme}.200`);
    return (React.createElement(ChakraTooltip, Object.assign({}, rest, { ref: ref, p: Spacing[2], label: label, className: className, "aria-label": label, placement: placement, hasArrow: hasArrow, bg: bgColor, backgroundColor: bgColor, colorScheme: scheme, shouldWrapChildren: true }), children));
});
Tooltip.displayName = "Tooltip";
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map